<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">年检订单</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="page_tab order_tab">
      <div class="page_tablist" v-for="(item,index) in navList" @click="changeNavIndex(index)">
        <div :class="index===navIndex? 'page_tabname' : 'page_tabname1'">{{item}}</div>
      </div>
    </div>
    <!-- 订单 开始 -->
    <div class="annualReview_orderList" v-if="list.length>0">
      <div class="annualReview_order" v-for="(item,index) in list">
        <div class="annualReview_orderTop">
          <div class="annualReview_ordertime">{{item.created_at_str}}</div>
          <div class="annualReview_ordernum">{{item.order.order_no}}</div>
        </div>
        <div class="annualReview_ordercenter">
          <div class="annualReview_orderstatusa1">
            <div class="annualReview_orderstatusas">
              <img class="annualReview_orderlogoimg" src="/static/storeClass.png"/>
              <div class="annualReview_ordertext">{{item.product_name}}</div>
            </div>
            <div class="annualReview_ordertextstatus">{{item.status_str}}</div>
          </div>
          <div class="annualReview_orderstatusa">
            <img class="annualReview_orderlogoimg" src="/static/phoneicon.png"/>
            <div class="annualReview_ordertext">手机号码：{{item.mobile}}</div>
          </div>
          <div class="annualReview_orderstatusa">
            <img class="annualReview_orderlogoimg" src="/static/nameicon.png"/>
            <div class="annualReview_ordertext">联系姓名：{{item.username}}</div>
          </div>
          <div class="annualReview_orderstatusa">
            <img class="annualReview_orderlogoimg" src="/static/jiecheaddress.png"/>
            <div class="annualReview_orderititle">联系地点:</div>
            <div class="annualReview_ordervalue">{{item.address}}</div>
          </div>
        </div>
        <div class="annualReview_orderbottom">
          <div class="annualReview_orderboleft">
            <img class="annualReview_orderlogoimg" src="/static/pinpaicjexing.png"/>
            <div class="annualReview_orderlogotext1">{{item.car_no}}</div>
          </div>
          <div class="annualReview_orderboright">
            <div class="annualReview_orderbotton"  v-if="item.order.type=='annual_review' && item.second_order_id" @click="toSecondPayDetail(item.secondOrder.order_no)"  >缴费详情</div>
            <div class="annualReview_orderbotton1" @click="toDetail(item.id)">服务详情</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单 结束 -->

    <!-- 暂无信息  开始 -->
    <div class="page_none" v-else>
      <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
    </div>
    <!-- 暂无信息  结束 -->
    <div @click="getMore()" class='annualReview_more' v-if="datalengthX">查看更多</div>
  </div>
</template>

<script>
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        navList: ["全部订单", "进行中",  "已完成"],
        navIndex: 0, // nav:导航栏指针,默认为0
        list: [],
        datalengthX: false, //判断是否要继续请求订单列,默认值false
        pages: 1, //判断是否要继续请求订单的第几页数,默认值1
        page_size: 20, // 列表每页页数,默认为20
      }
    },
    created() {
      // this.request('getOrderList')
      let that = this
      //上一页面传过来的参数
      if (that.$route.query.order_status) {
        that.navIndex = that.$route.query.order_status
      }
      console.log(that.navIndex)
      // 读接口获取订单列表
      that.changeNavIndex(that.navIndex)
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //点击切换导航栏指针
      changeNavIndex(index, page = 1, reset_list = true) {
        let that = this
        let requestData = {
          order_status: [],
          page: page,
          page_size: that.page_size,
        }
        this.navIndex = index
        this.pages = page
        if (reset_list) {
          this.list = []
        }
        console.log("that.navIndex", that.navIndex)
        switch (that.navIndex) {
          case 0:
            break
          case 1:
            requestData.status = [1,10,20,21]
            break
          case 2:
            requestData.status = [30]
            break
        }
        that.request('getOrderList', requestData)
      },
      //二次订单详情
      toSecondPayDetail(orderno){
        this.$router.push({
          path: "/SecondPayment",
          query:{
            order_no:orderno
          }
        })
      },
      //点击跳转到订单详情页面
      toDetail(orderno) {
        this.$router.push({
          name: 'annualReviewDetail',
          query: {
            id: orderno,
            navIndex: this.navIndex
          }
        })
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单信息列表
          case 'getOrderList':
            httper.post('/annual-review/get-list', requestData, res => {
              let lengthX = res.data.length - 20 === 0 //判断列是否20条
              that.datalengthX = lengthX
              // that.list = [...this.list, ...res.data] //数据拼接,
              console.log("res", res)
              if (res.data.length > 0) {
                let list = that.list;
                for (let i = 0; i < res.data.length; i++) {
                  list.push(res.data[i]);
                }
                that.list = list
              }
            }, true)
            break
        }
      },
      //查看更多
      getMore() {
        let that = this
        if (!that.datalengthX) {
          that.$toast({
            message: '没有更多了'
          })
          return
        }
        let page = (that.pages) + 1
        that.changeNavIndex(that.navIndex, page, false)
      },

    }
  }
</script>

<style>
  .order_tab {
    background-color: #fff;
        position: fixed;
        top: 50px;
  }
  .annualReview_orderList {
    width: calc(100% - 40px);
    margin: 20px;
    margin-top: 60px;
  }

  .annualReview_order {
    width: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .annualReview_orderTop {
    width: 100%;
    padding: 10px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #D2D2D2;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annualReview_ordertime {
    font-size: 12px;
    color: #363636;

  }

  .annualReview_ordernum {
    font-size: 12px;
    color: #363636;
  }

  .annualReview_ordercenter {
    width: 100%;
    padding: 10px 10px 0 10px;
    box-sizing: border-box;
     border-bottom: 1px solid #D2D2D2;
  }

  .annualReview_orderbotop {
    width: 100%;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annualReview_ordernamemesg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annualReview_orderlogo {
    width: 23px;
    height: 21px;
    margin-right: 10px;
  }

  .annualReview_ordername {
    font-size: 12px;
    color: #363636;
  }

  .annualReview_orderstatus {
    font-size: 12px;
    color: #EA6E56;
  }

  .annualReview_orderprice {
    font-size: 12px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .annualReview_more {
    font-size: 12px;
    color: #363636;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .annualReview_orderstatusa{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    align-items: center;

  }
  .annualReview_orderstatusas{
    margin-bottom: 5px;
    display: flex;
    align-items: center;

  }
  .annualReview_orderstatusa1{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .annualReview_orderlogoimg{
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }
  .annualReview_ordertext{
    font-size: 14px;
    color: #363636;
  }
  .annualReview_ordertextstatus{
    font-size: 14px;
    color: #FD8C00;
  }
  .annualReview_orderititle{
    font-size: 14px;
    color: #363636;
    width:21%;
  }
  .annualReview_ordervalue{
    font-size: 14px;
    color: #363636;
    width: 70%;
  }
  .annualReview_orderbottom{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .annualReview_orderboleft{
    display: flex;
    align-items: center;
  }
  .annualReview_orderlogotext1{
    font-size: 14px;
    color: #666666;
  }
  .annualReview_orderboright{
    display: flex;
    align-items: center;

  }
  .annualReview_orderbotton{
    width: 58px;
    height: 23px;
    background: #F5B732;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 12px;
    margin-right: 15px;
  }
  .annualReview_orderbotton1{
    width: 58px;
    height: 23px;
    background: #53D99F;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/annualReviewList.vue